module.exports = __webpack_public_path__ + "static/L2_content_text_meaning_3_eg-edf6fe3ed9e9c398987a7b1f6df5bd22.png";